import RecurringDownloadReportPage from "./pages/RecurringDownloadReportPage";

export const recurringRoutes = (prefix = "recurring") => [
  {
    name: "RecurringDownloadReportPage",
    path: `${prefix}/report`,
    component: RecurringDownloadReportPage
  }
];



// WEBPACK FOOTER //
// ./src/features/subscriptions/modules/recurring/routes.js